import { vulnerabilityClient } from "../http-common";

class VulnerabilityAPIService {
  async get(branch: string) {
    return vulnerabilityClient(`/branch/${branch}.json`);
  }
}

export default new VulnerabilityAPIService();
